import { render, staticRenderFns } from "./rego-customer-create-account.vue?vue&type=template&id=af0f5d98&scoped=true&"
import script from "./rego-customer-create-account.vue?vue&type=script&lang=js&"
export * from "./rego-customer-create-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0f5d98",
  null
  
)

export default component.exports